export enum SmptModeTypeEnum {
  GENERAL = 'GENERAL',
  TEST = 'TEST',
}
